<template>
  <div id="termlyreport">
    <div class="row">
      <div class="col-lg-12 reportArea">
        <div class="row reportAreaTitlePart">
          <div class="col-lg-12 reportAreaTitle"><i class="material-icons">assignment</i> {{ lang('Summative Report History') }}</div>
        </div>
        <div v-if="mode === 'View'" class="reportAreaTitlePart">
          <div style="height: 20px"></div>
        </div>
        <div v-if="mode !== 'View'" class="row reportAreaContentPart" id="reportAreaContentPart">
          <div class="col-lg-2">
            <label class="font">{{ lang('Academic Year') }}</label>
            <academic-year-select v-model="ddlSelectedAcademicYearID" class="pro-edt-select slAcademicYear" @change="onAcademicYearChange()" />
          </div>
          <div class="col-lg-2">
            <label class="lblSelectClass font">{{ lang('Select Class') }}</label>
            <el-select v-model="ddlClass" :placeholder="lang('Select Class')" class="pro-edt-select slClass" @change="LoadStudents()" id="ddlClass">
              <el-option
                v-for="item in ddlClassList"
                :key="item.PK_Class_ID"
                :label="item.CLS_ClassName.trim() + ' ' + item.CLS_Batch.trim()"
                :value="ddlSelectedAcademicYearID + ',' + item.PK_Course_ID.trim() + ',' + item.PK_Class_ID.trim()"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-lg-2">
            <label class="lblSelectStudent font">{{ lang('Select Student') }}</label>
            <el-select v-model="ddlStudent" :placeholder="lang('Select Student')" class="pro-edt-select slStudent" @change="action('List', '')" id="ddlStudent">
              <el-option v-for="item in dllStudentList" :key="item.Student_ID" :label="item.Student_Name.trim()" :value="item.Student_ID"> </el-option>
            </el-select>
          </div>
          <div class="col-lg-2">
            <label class="font d-block">&nbsp;</label>
            <el-date-picker
              style="border: none; width: 100%"
              v-model="filterByDateRange"
              type="daterange"
              :range-separator="lang('ETo')"
              :start-placeholder="lang('Start Date')"
              :end-placeholder="lang('End Date')"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              @change="action('List', '')"
            >
            </el-date-picker>
          </div>
          <div class="col-lg-1">
            <label class="font d-block">&nbsp;</label>
            <span class="spSearchIcon" @click="action('ListSearch', '')"><i class="material-icons searchIcon">search</i></span>
          </div>
        </div>
        <div v-if="mode === 'No'" class="col-lg-12 empty-list_image reportAreaContentPart2" id="divEditList">
          <strong v-if="ddlClass === ''">{{ lang('Select Class') }}</strong>
          <strong v-else>{{ lang('Select Action') }}</strong>
          <img src="../assets/notfound.png" />
        </div>
        <div v-if="mode === 'List'" class="row reportAreaContentPart2" id="divEditList">
          <div v-if="termlyReportListInt.length < 1" class="col-lg-12 empty-list_image">
            <strong>{{ lang('No Termly Report Found') }}...</strong>
            <img src="../assets/notfound.png" />
          </div>
          <div v-if="termlyReportListInt.length > 0" class="col-lg-12">
            <K2Row justify_content="flex-end" class="mb-3">
              <el-button v-on:click="handleBulkDownload()" class="actionButton btnDownload">
                {{ lang('Bulk Download') }}
              </el-button>
            </K2Row>
            <data-tables :data="termlyReportListInt" class="listTable" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                v-for="termlyReportListInfo in termlyReportList"
                :prop="termlyReportListInfo.prop"
                :label="termlyReportListInfo.label"
                :key="termlyReportListInfo.prop"
                sortable="custom"
              >
              </el-table-column>
              <el-table-column :label="lang('Status')" width="150px">
                <template slot-scope="scope">
                  <span :class="scope.row.TeRpStatus === 'Active' ? 'actionButtonActive' : 'actionButtonPending'">
                    {{ lang(scope.row.TeRpStatus) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="lang('Action')" width="100px">
                <template slot-scope="scope">
                  <button class="actionButtonActive" @click="action('Active', scope.row.TeRpID, scope.row.TeRpStudentID)">
                    {{ lang('View') }}
                  </button>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
        <div v-if="mode === 'View'" class="row reportAreaContentPart2">
          <div class="col-lg-6 reportAreaContentPart2ReportType">
            <label class="lblTermlyReportList">{{ lang('Termly Report List') }}</label>
          </div>
          <div class="col-lg-6 reportAreaContentPart2Button">
            <el-button v-on:click="action('BackToList', '')" class="font btnBackToList">
              {{ lang('Back To List') }}
            </el-button>
          </div>
          <div class="col-lg-12 row reportAreaContentPart2NameClass">
            <div class="col-lg-6">
              {{ currentClassStudentName }}
            </div>
            <div class="col-lg-6" style="text-align: right">
              <el-button v-on:click="downloadTermlyReport()" class="actionButton btnDownload">
                {{ lang('Download') }}
              </el-button>
            </div>
          </div>
          <div class="col-lg-12 reportAreaContentPart2Header">
            <div id="divNewTitle">
              <label class="font">{{ lang('Title') }}</label>
            </div>
            <div v-for="(flowInfo, index) in userFlow">
              <div v-if="flowInfo.Type === 'Creator' || flowInfo.Type === 'Main'">
                <div v-for="comment in getCommentByDomain('', 'header', flowInfo.ConID)">
                  <div class="groupComment row">
                    <label class="font eachCommentNo1"></label>
                    <label class="font eachCommentComment1" v-html="getCommentHTML(comment.TeRpCMComment)"></label>
                    <label class="font eachCommentInfo1">{{ comment.CONname }}</label>
                  </div>
                </div>
                <div v-for="comment in getCommentByDomain('', 'headerCN', flowInfo.ConID)">
                  <div class="groupComment row">
                    <label class="font eachCommentNo1"></label>
                    <label class="font eachCommentComment1" v-html="getCommentHTML(comment.TeRpCMComment)"></label>
                    <label class="font eachCommentInfo1">{{ comment.CONname }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 reportAreaContentPart2StudentInfo">
            <div>
              <label>{{ lang('Student Information') }}</label>
            </div>
            <hr />
            <div class="row divStudentInfo">
              <div class="col-lg-6">
                <label class="font">{{ lang('Name of child') }}: {{ studentInfoPartName }}</label>
              </div>
              <div class="col-lg-6">
                <label class="font">{{ lang('Current Age') }}: {{ studentInfoPartAge }}</label>
              </div>
              <div class="col-lg-6">
                <label class="font">{{ lang('Date of Birth') }}: {{ studentInfoPartDob }}</label>
              </div>
              <div class="col-lg-6">
                <label class="font">{{ lang('Class') }}: {{ studentInfoPartClass }}</label>
              </div>
              <div class="col-lg-6">
                <label class="font">
                  {{ lang('Period of Report') }}: {{ getReportPeriod(studentInfoPartSemdFrom, studentInfoPartSemdTo) }}
                </label>
              </div>
              <div class="col-lg-6">
                <label class="font">
                  {{ lang('Date of Joining EtonHouse') }}:
                  {{ moment(studentInfoPartJoinDate, 'DD/MM/YYYY HH:mm:ss').format('Do MMMM YYYY') }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-12 reportAreaContentPart2Summary">
            <div class="reportAreaContentPart2SummaryTitle">
              <label class="lblReportAreaContentPart2Summary">{{ lang('Summary of In School Learning') }}</label>
            </div>
            <hr />
            <div class="divEachDomain" v-for="domain in displayDomains">
              <div v-if="checkIsOptionalDomain(domain.Domain, 'data')">
                <div>
                  <label class="font">
                    {{ domain.Domain }}
                    <span v-for="(item, key, index) in groupDomainMapChinese" v-if="domain.Domain === item">{{ key }}</span>
                  </label>
                </div>

                <div v-for="(flowInfo, index) in userFlow">
                  <div v-if="flowInfo.Type === 'Creator' || flowInfo.Type === 'Main'">
                    <div v-for="comment in getCommentByDomain(domain.Domain, 'data', flowInfo.ConID)">
                      <div class="groupComment row">
                        <label class="font eachCommentNo1"></label>
                        <label class="font eachCommentComment1" v-html="getCommentHTML(comment.TeRpCMComment)"></label>
                        <label class="font eachCommentInfo1">{{ comment.CONname }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 reportAreaContentPart2Summary" v-if="checkIsOptionalDomain('', 'single')">
            <div class="reportAreaContentPart2SummaryTitle">
              <label class="lblReportAreaContentPart2Summary">{{ lang('Comments from the Language Specialist Teachers') }}</label>
            </div>
            <hr />
            <div class="divEachDomain" v-for="flowInfo in userFlow">
              <div v-if="flowInfo.Type === 'NonMain'">
                <div v-for="(comment, index) in getCommentByDomain('', 'single', flowInfo.ConID)">
                  <div>
                    <label class="font">{{ flowInfo.ConName }} ( {{ flowInfo.Position }} )</label>
                  </div>
                  <div class="groupComment row">
                    <label class="font eachCommentNo2"></label>
                    <label class="font eachCommentComment2" v-html="getCommentHTML(comment.TeRpCMComment)"></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import { lang } from '../locale/index'
import Vue from 'vue'
import AcademicYearSelect from '../components/AcademicYearSelect.vue'
import K2Row from '../uiComponents/k2Row/k2Row'
import { getPeriodReport } from './termlyReport/mixins/getPeriodReport'
import { groupDomain } from './termlyReport/mixins/groupDomain'
import { checkIsOptionalDomain } from './termlyReport/mixins/checkIsOptionalDomain'

export default {
  name: 'TermlyReportPreviousYears',
  components: {
    AcademicYearSelect,
    K2Row,
  },
  mixins: [getPeriodReport, groupDomain, checkIsOptionalDomain],
  data() {
    return {
      userID: '',
      ddlSelectedAcademicYearID: '',
      ddlStudent: '',
      dllStudentList: [],
      ddlClass: '',
      ddlClassList: [],
      mode: 'No',
      currentClassStudentName: '',
      currentTermlyReportID: '',
      userFlow: [],

      termlyReportListInt: [],
      termlyReportList: [
        {
          prop: 'StudentName',
          label: lang('Student Name'),
        },
        {
          prop: 'Title',
          label: lang('Title'),
        },
        {
          prop: 'TeRpCreatedOn_convert',
          label: lang('Date'),
        },
      ],

      groupDomainMapChinese: {},
      termlyReportDomainComment: [],

      studentInfoPartName: '',
      studentInfoPartAge: '',
      studentInfoPartDob: '',
      studentInfoPartClass: '',
      studentInfoPartJoinDate: '',
      studentInfoPartSemdFrom: '',
      studentInfoPartSemdTo: '',

      filterByDateRange: null,
      selectedReports: [],
    }
  },
  props: ['passTermlyReportID'],
  computed: {
    displayDomains() {
      const knownDomains = this.getDefaultGroupDomain()
      const knownDomainNames = knownDomains.map(m => m.Domain)
      const extraDomains = []

      this.termlyReportDomainComment.forEach(m => {
        if (m.TeRpCMType === 'Domain' && !knownDomainNames.includes(m.TeRpCMDomain) && !extraDomains.includes(m.TeRpCMDomain)) {
          extraDomains.push(m.TeRpCMDomain)
        }
      })

      return [...knownDomains, ...extraDomains.map(Domain => ({ Domain }))]
    },
  },
  async created() {
    this.GetTermlyReportDomainMapping()
  },
  async mounted() {
    this.userID = Cookies.get('userIDSession')
  },
  methods: {
    lang,
    async GetTermlyReportDomainMapping() {
      try {
        let tempGroupDomainMapChinese = {}

        const response = await DataSource.shared.getTermlyReportDomainMapping()
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report Domain Mapping: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report Domain Mapping: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            response.Table.forEach(m => {
              Vue.set(tempGroupDomainMapChinese, m.PlnDpMmSub, m.PlnDpMmMain)
            })

            this.groupDomainMapChinese = tempGroupDomainMapChinese
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async onAcademicYearChange() {
      this.ddlClass = ''
      this.ddlStudent = ''
      this.dllStudentList = []
      this.clear('changeAction')
      await this.BindClasses()
    },
    async BindClasses() {
      try {
        const response = await DataSource.shared.getClassIncludeClosed(this.ddlSelectedAcademicYearID)
        if (response) {
          if (response.code === '2') {
            console.log('Get Class Include Closed: No Record')
          } else if (response.code === '99') {
            console.log('Get Class Include Closed: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.ddlClassList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async LoadStudents() {
      try {
        this.clear('changeClass')

        this.$vs.loading()

        const classId = this.ddlClass.split(',')[2]
        const response = await DataSource.shared.getStudentsWithTermlyReportByClassId(classId)
        if (response) {
          if (response.code === '2') {
            this.$notify.error({
              title: 'Error',
              message: 'No Student Found...',
            })
          } else if (response.code === '99') {
            console.log('Get Class Student Include Inactive: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.dllStudentList = response.Table
          }
        }

        this.$vs.loading.close()
        this.action('List', '')
      } catch (e) {
        this.results = e
      }
    },
    async LoadTermlyReporList() {
      try {
        this.$vs.loading()

        let dateFrom, dateTo
        if (this.filterByDateRange && this.filterByDateRange.length) {
          dateFrom = this.filterByDateRange[0]
          dateTo = this.filterByDateRange[1]
        }

        const currentClassID = this.ddlClass.split(',')
        const response = await DataSource.shared.getTermlyReportList(this.ddlStudent, currentClassID[2], dateFrom, dateTo)
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report List: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report List: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.termlyReportListInt = response.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async getTermlyReport(termlyReportID) {
      try {
        const response = await DataSource.shared.getTermlyReport(termlyReportID)
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.userFlow = response.dsFlow.Flow
            this.termlyReportDomainComment = response.dsKgm_TermlyReportComment.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async downloadTermlyReport() {
      try {
        try {
          this.$vs.loading()
          const response = await DataSource.shared.generateDownloadTermlyReportPDF(this.currentTermlyReportID)
          if (response) {
            this.$vs.loading.close()

            var byteChar = atob(response)
            var byteNo = new Array(byteChar.length)
            for (var i = 0; i < byteChar.length; i++) {
              byteNo[i] = byteChar.charCodeAt(i)
            }

            var byteArray = new Uint8Array(byteNo)
            var file = new Blob([byteArray], { type: 'application/pdf;base64' })
            var fileUrl = URL.createObjectURL(file)

            window.open(fileUrl, '_blank', 'width=500, height=500')

            this.$vs.loading.close()
          }
        } catch (e) {
          this.results = e
        }
      } catch (e) {
        this.results = e
      }
    },
    async getTermlyReportStudentInfoPart() {
      try {
        let currentClassID = this.ddlClass.split(',')

        const response = await DataSource.shared.getTermlyReportStudentInfoPart(this.ddlStudent, currentClassID[2])
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report Student Info Part : No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report Student Info Part : Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.studentInfoPartName = response.ds.Table[0].Name
            this.studentInfoPartAge = response.ds.Table[0].Age
            this.studentInfoPartDob = response.ds.Table[0].Dob
            this.studentInfoPartJoinDate = response.ds.Table[0].Regst_Date
            this.studentInfoPartSemdFrom = response.ds.Table[0].SEMD_FromDate
            this.studentInfoPartSemdTo = response.ds.Table[0].SEMD_ToDate

            let currentClassName = this.ddlClassList.filter(m => m.PK_Class_ID === currentClassID[2])
            this.studentInfoPartClass = currentClassName[0].CLS_ClassName
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    handleSelectionChange(val) {
      this.selectedReports = val
    },
    async handleBulkDownload() {
      if (this.selectedReports.length < 1) {
        this.$notify({ title: 'Required', message: 'Please select at least one report...' })
        return
      }

      this.$vs.loading()

      try {
        for (const report of this.selectedReports) {
          const response = await DataSource.shared.generateDownloadTermlyReportPDF(report.TeRpID)

          if (!response) {
            continue
          }

          const byteChar = atob(response)
          const byteNo = new Array(byteChar.length)
          for (let i = 0; i < byteChar.length; i++) {
            byteNo[i] = byteChar.charCodeAt(i)
          }

          const byteArray = new Uint8Array(byteNo)
          const file = new Blob([byteArray], { type: 'application/pdf;base64' })
          const fileUrl = URL.createObjectURL(file)

          const link = document.createElement('a')
          link.href = fileUrl
          link.download = `${report.StudentName || report.TeRpID} - ${report.Title || 'Summative Report'}.pdf`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(fileUrl)
        }
      } catch (e) {
        this.$notify.error({ title: 'Error', message: 'Something went wrong downloading the reports.' })
      } finally {
        this.$vs.loading.close()
      }
    },
    clear(value) {
      this.termlyReportListInt = []
      this.termlyReportDomainComment = []
      this.currentTermlyReportID = ''
      this.userFlow = []

      if (value === 'All') {
        this.dllStudentList = []
        this.ddlStudent = ''
        this.ddlClass = ''
        this.mode = 'No'
        this.filterByDateRange = null
      } else if (value === 'changeStudent') {
        this.mode = 'No'
        this.fnCurrentClassStudentName()
      } else if (value === 'changeClass') {
        this.dllStudentList = []
        this.ddlStudent = ''
        this.mode = 'No'
      } else if (value === 'changeAction') {
      }
    },
    action(value, termlyReportID, studentID) {
      if (value === 'List') {
        if (this.ddlClass === '') {
          this.$notify({
            title: 'Required',
            message: 'Please select class....',
          })
        } else {
          this.mode = 'List'
          this.clear('changeAction')
          this.LoadTermlyReporList()
        }
      } else if (value === 'Active') {
        if (studentID) this.ddlStudent = studentID
        this.mode = 'View'
        this.clear('changeAction')
        this.currentTermlyReportID = termlyReportID
        this.getTermlyReport(termlyReportID)
        this.getTermlyReportStudentInfoPart()
      } else if (value === 'BackToList') {
        this.clear('All')
        this.mode = 'List'
      }
    },
    fnCurrentClassStudentName() {
      this.currentClassStudentName = 'Error'

      let currentClassID = this.ddlClass.split(',')
      let currentClassName = this.ddlClassList.filter(m => m.PK_Class_ID === currentClassID[2])

      let currentStudentName = this.dllStudentList.filter(m => m.Student_ID === this.ddlStudent)

      this.currentClassStudentName = currentClassName[0].CLS_ClassName
      this.currentClassStudentName += ' > ' + currentStudentName[0].First_Name

      if (currentStudentName[0].Middle_Name !== '') {
        this.currentClassStudentName += ' ' + currentStudentName[0].Middle_Name
        this.currentClassStudentName += ' ' + currentStudentName[0].Last_Name
      } else {
        this.currentClassStudentName += ' ' + currentStudentName[0].Last_Name
      }
    },
    getCommentHTML(value) {
      if (value === undefined) {
        return ''
      } else {
        return value.replace(/(?:\r\n|\r|\n)/g, '<br>')
      }
    },
    getCommentByDomain(domain, type, userID) {
      if (type === 'data') {
        return this.termlyReportDomainComment.filter(m => m.TeRpCMDomain === domain && m.TeRpCMConID === userID)
      } else if (type === 'header') {
        return this.termlyReportDomainComment.filter(m => m.TeRpCMType === 'Header' && m.TeRpCMConID === userID)
      } else if (type === 'headerCN') {
        return this.termlyReportDomainComment.filter(m => m.TeRpCMType === 'HeaderCN' && m.TeRpCMConID === userID)
      } else if (type === 'content') {
        return this.termlyReportDomainComment.filter(m => m.TeRpCMType === 'Content' && m.TeRpCMConID === userID)
      } else if (type === 'single') {
        return this.termlyReportDomainComment.filter(m => m.TeRpCMType === 'Single' && m.TeRpCMConID === userID)
      }
    },
  },
}
</script>

<style scoped>
.row {
  margin-right: 0;
  margin-left: 0;
}
.font {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.reportArea {
  padding: 20px;
}
.reportAreaContentPart {
  margin-top: 30px;
  background: #f8faff;
  border-radius: 8px 8px 0 0;
  padding: 20px 0;
  border-bottom: 0.5px solid #d3d9e8;
}
.reportAreaTitle {
  text-align: left;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #536170;
}
.lblSelectClass,
.lblSelectStudent {
  color: #536170;
}
.spSearchIcon {
  background: #426dff;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
}
.searchIcon {
  text-align: center;
  margin-top: 10px;
}
.slClass,
.slStudent {
  display: block;
}
.reportAreaContentPart2 {
  padding: 20px 0;
  background: #ffffff;
}
.lblNewTermlyReport,
.lblTermlyReportList {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: #4f4f4f;
}
.reportAreaContentPart2ReportType,
.reportAreaContentPart2Button,
.reportAreaContentPart2Header,
.reportAreaContentPart2StudentInfo,
.reportAreaContentPart2Summary {
  margin-bottom: 40px;
}
.reportAreaContentPart2Button {
  text-align: right;
}
.empty-list_image {
  width: 100%;
}
.reportAreaContentPart2StudentInfo label,
.lblReportAreaContentPart2Summary,
.reportAreaContentPart2Header label {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #536170;
}
.reportAreaContentPart2SummaryTitle,
.divEachDomain {
  margin-bottom: 20px;
}
.actionButtonActive {
  background: #19b600;
  border-radius: 5px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  padding: 10px;
  border: none;
}
.actionButtonPending {
  background: #91a3b6;
  border-radius: 5px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  padding: 10px;
  border: none;
}
.btnBackToList {
  background: #426dff;
  border-radius: 5px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
}
.reportAreaContentPart2NameClass {
  background: #f8faff;
  text-align: left;
  padding-top: 15px;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-top: 1px solid #dde6fc;
  border-bottom: 1px solid #dde6fc;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #536170;
}
.groupComment {
  display: flex;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 10px;
}
.btnDownload {
  background: #ea4c89;
  border-radius: 5px;
  color: #ffffff;
}
.eachCommentNo1 {
  width: 5px;
  background: #ecbc40 !important;
  text-align: center;
  color: #ffffff !important;
}
.eachCommentComment1 {
  width: calc(70% - 5px - 25px);
  background: rgba(236, 188, 64, 0.15) !important;
  text-align: left;
  color: #536170 !important;
  padding: 5px;
}
.eachCommentInfo1 {
  width: 30%;
  background: rgba(236, 188, 64, 0.15) !important;
  text-align: right;
  color: #687786 !important;
  padding: 5px;
}
.inputFilterPostTitle {
  background: #f8faff;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 5px;
}
.eachCommentNo2 {
  width: 5px;
  background: #ecbc40 !important;
  text-align: center;
  color: #ffffff !important;
}
.eachCommentComment2 {
  width: calc(100% - 5px - 25px);
  background: rgba(236, 188, 64, 0.15) !important;
  text-align: left;
  color: #536170 !important;
  padding: 5px;
}
.reportAreaTitlePart {
  margin-bottom: 10px;
}
.divStudentInfo .col-lg-6 {
  padding: 0px;
}
.divVerficationTeacherTitle {
  color: #ffffff;
  background: #426dff;
  padding: 10px;
  border-radius: 5px 5px 0px 0px;
  text-align: left;
  margin-bottom: 10px;
}
.spanVerification {
  color: #ffffff;
  font-size: 20px;
}
.spanVerificationMsg {
  color: #ffffff;
  font-size: 11px;
}
.divVerficationTeacherMsg {
  margin-bottom: 10px;
  color: #ffffff;
  background: #426dff;
  text-align: left;
  padding: 5px;
  font-size: 10px;
}
.divVerficationTeacherDetails {
  background: #f8faff;
  width: 49%;
  float: left;
  border: 1px solid rgba(145, 163, 182, 0.15);
  box-sizing: border-box;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}
.divVerficationTeacherDetailsDisable {
  background: #dde4f5 !important;
  color: #a0abc7 !important;
}
.divVerficationTeacherDetailsRight {
  margin-left: 2%;
}
.spanVerficationTeacherDetailsIcon {
  float: left;
  width: 30px;
  text-align: left;
}
.spanVerficationTeacherDetailsName {
  float: left;
  width: calc(50% - 15px);
  text-align: left;
}
.spanVerficationTeacherDetailsRole {
  float: left;
  width: calc(50% - 15px);
  text-align: left;
}
.redborder {
  border: 1px solid red;
}
</style>

<style>
#termlyreport {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  color: #536170;
}
#termlyreport .slAcademicYear .el-input__inner,
#termlyreport .slClass .el-input__inner,
#termlyreport .slStudent .el-input__inner {
  color: #426dff;
  background: #ffffff;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 5px;
}
#termlyreport .listTable .el-table__header-wrapper th {
  background: #e9edf7;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #222222;
}
#termlyreport .listTable .el-table__row td,
#portfolio_component .indicatorTable .el-table__empty-block {
  background: #f8faff;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #5f5f5f;
}
#termlyreport .el-date-editor .el-range-input {
  width: 100px;
}
#termlyreport .el-range-editor.el-input__inner {
  width: initial;
}
#termlyreport .el-date-editor .el-range-separator {
  min-width: 25px;
}
</style>
